import { render } from "./upload-image-component.vue?vue&type=template&id=c6912a48&ts=true"
import script from "./upload-image-component.ts?vue&type=script&lang=ts"
export * from "./upload-image-component.ts?vue&type=script&lang=ts"

import "./upload-image-component.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__